import { useEffect, useState } from 'react';
import { retryAfterSeconds, rateLimitMessage } from './rateLimit';

export function useRateLimitRetry() {
  const [message, setMessage] = useState<string | null>(null);
  const [until, setUntil] = useState(0);
  const [waiting, setWaiting] = useState(false);
  useEffect(() => {
    if (!until) return;
    const timer = setTimeout(() => setWaiting(false), Math.max(0, until - Date.now()));
    return () => clearTimeout(timer);
  }, [until]);
  return {
    message, waiting,
    clear: () => setMessage(null),
    limited: (error: unknown) => {
      const seconds = retryAfterSeconds(error);
      setMessage(rateLimitMessage(seconds));
      setWaiting(true);
      setUntil(Date.now() + seconds * 1000);
    },
  };
}
